import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { DataService } from '@app-core/services/data/data.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent implements OnInit, OnDestroy {
  @Input() public alertType: string;
  @Input() public alertActionText: string;
  @Input() public showHelpIcon: boolean = false;
  @Input() public insideTable: boolean;
  @Input() public removeMargin: boolean;
  @Input() public requireBorder: boolean;

  @Output() public alertAction = new EventEmitter();
  @Output() public alertHelpAction = new EventEmitter();

  public currentTheme = 'light';
  public ngUnsubscribe = new Subject<void>();

  constructor(private dataService: DataService) {}

  public alertActionEvent() {
    this.alertAction.emit();
  }

  public alertHelpActionEvent() {
    this.alertHelpAction.emit();
  }

  public ngOnInit() {
    this.dataService._currentTheme.subscribe((value: string) => {
      if (value) {
        this.currentTheme = value;
      }
    });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
